import React from "react";
import Dialog from "@mui/material/Dialog";
import useMediaQuery from "@mui/system/useMediaQuery";
import { useTheme } from "@mui/joy";
import IotCommissioningWizard, { IotCommissioningWizardProps } from "./index";

/**
 * Dialog shell of the commissioning checklist — same chrome as CreateInstalledBaseEventModal.
 * The checklist is taller than most screens, so the paper scrolls with the library header
 * (title + close) pinned on top; the footer pins itself to the bottom (see index.tsx).
 * BasicModalContent has no sticky option, hence the selector on its first child.
 */
const STICKY_HEADER_SX = {
    "& > .flex-column > :first-of-type": {
        position: "sticky",
        top: 0,
        zIndex: 2,
        maxHeight: "none",
        mt: "-16px",
        mx: "-16px",
        px: "16px",
        py: "12px",
        backgroundColor: "#fff",
    },
};
const IotCommissioningWizardModal = (props: IotCommissioningWizardProps) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down("md"));
    return (
        <Dialog open onClose={props.onClose} fullScreen={isFullScreen} PaperProps={{ sx: STICKY_HEADER_SX }}>
            <IotCommissioningWizard {...props} />
        </Dialog>
    );
};

export default IotCommissioningWizardModal;
